import { render } from "./PageLoader.vue?vue&type=template&id=120996e0"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=120996e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__